export const fetchCurrentUser = () => ({
  type: "GET_CURRENT_USER"
});
